import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseSiteService, RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CustomInfluenzaService } from '../custom-influenza.service';

@Component({
    selector: 'app-view-reservation',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './view-reservation.component.html',
    styleUrls: ['./view-reservation.component.scss'],
    standalone: false
})
export class ViewReservationComponent implements OnInit, OnDestroy {
  tabSelected = 'reservationOverview';
  isScheduleShipments: boolean = false;

  stsFlag: boolean = false; //default false

  reservationNum: string = '';
  activeSeasonId: any = '';
  reservationStatus: string = '';
  notConfirmedMessage: string = '';

  baseSiteId: string;
  showEditCTAShip: boolean = true; // will turn false if line item status is shipped or completed(value passed from dashboard while navigating)
  userReceivingHours: boolean = false; // will turn true if such passed from dashboard
  baseSub: Subscription;

  constructor(
    private readonly user: UserAccountFacade,
    private readonly cd: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly baseSiteService: BaseSiteService,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly sharedService: SharedService,
    private readonly routingService: RoutingService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.stsFlag = this.sharedService.getSessionStorage('isStsEligible');
    this.showEditCTAShip = this.sharedService.getSessionStorage('fluEditCta');
    this.userReceivingHours = this.sharedService.getSessionStorage(
      'userFluReceivingHours'
    );


    this.isScheduleShipments = this.activatedRoute.snapshot.queryParams
      .scheduleShipments
      ? true
      : false;
    this.reservationNum = this.activatedRoute.snapshot.queryParams.orderNo
      ? this.activatedRoute.snapshot.queryParams.orderNo
      : '';
    const seasonID = this.sharedService.getSessionStorage('activeSeasons');
    if (seasonID) {
      this.activeSeasonId = seasonID;
    }
    this.reservationStatus =
      this.sharedService.getSessionStorage('reservationStatus');
    this.notConfirmedMessage =
      this.sharedService.getSessionStorage('alertMessage');
    this.cd.detectChanges();

    if (this.stsFlag && this.reservationStatus === 'Confirmed') {
      if (this.isScheduleShipments) {
        this.tabSelected = 'reservationSchedule';
        document.getElementById('reservationSchedule').style.display = 'block';
        document.getElementById('reservationOverview').style.display = 'none';
      } else {
        this.tabSelected = 'reservationOverview';
        document.getElementById('reservationSchedule').style.display = 'none';
        document.getElementById('reservationOverview').style.display = 'block';
      }
    }
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
  }
  tabNavigation(content, id) {
    const idArray = ['reservationOverview', 'reservationSchedule'];
    this.tabSelected = content;

    for (const item of idArray) {
      if (id === item) {
        document.getElementById(item).style.display = 'block';
      } else {
        document.getElementById(item).style.display = 'none';
      }
    }
  }

  backToDashboard() {

    this.routingService.goByUrl('influenza/dashboard?fromFlu=yes');
  }

  exportXls() {
    this.influenzaService.viewReservationXlsdownload.next(this.tabSelected);
  }

  OnFluPrint() {
    this.influenzaService.printOverviewPage.next(true);
    window.print();
  }
  redirectToSelectVaccine() {
    this.router.navigate(['/fluCategoryPage'], {
      queryParams: { editReservation: 'yes', orderNo: this.reservationNum },
    });
  }
}
